import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import { AuthContext } from '../../../context';

import mutations from '../../../graphql/mutations';

import style from './index.module.scss';

const {
  answerMutations: { ANSWER_ACTIONS_UPDATE },
} = mutations;

const UserMutation = ({ mutationInput, children }) => {
  return (
    <Mutation mutation={ANSWER_ACTIONS_UPDATE}>
      {(mutation, { loading, error, data }) => (
        <span
          className={style.action}
          onClick={() => mutation({ variables: { input: mutationInput } })}
        >
          {children}
        </span>
      )}
    </Mutation>
  );
};

function AnswerActions({ answer }) {
  const { currentUser } = useContext(AuthContext);
  const votes = answer.upvotedBy.length - answer.downvotedBy.length;

  const isUpvoted = () => {
    if (votes >= 0) {
      return true;
    }
  };

  return (
    <div className={`row ${style.actions}`}>
      <div className={`col ${style['col--votes']}`}>
        <UserMutation
          mutationInput={{ 
            answerId: answer.id, 
            userId: currentUser.id, 
            updateType: 'vote',
            voteType: 'up', 
          }}
        >
          <i className='fas fa-chevron-up'></i>
          <span> Upvote</span>
          {isUpvoted() && <span> · {votes}</span>}
        </UserMutation>
        <UserMutation
          mutationInput={{
            answerId: answer.id,
            userId: currentUser.id,
            updateType: 'vote',
            voteType: 'down',
          }}
        >
          <i className='fas fa-chevron-down'></i>
          <span> Downvote</span>
          {!isUpvoted() && <span> · {votes}</span>}
        </UserMutation>
      </div>
      <div className={`col ${style['col--share']}`}>
        <span className={style.action}>
          <i className='fas fa-share'></i>
          <span> Share</span>
        </span>
        <UserMutation
          mutationInput={{
            answerId: answer.id,
            userId: currentUser.id,
            updateType: 'bookmark',
          }}
        >
          <i className='fas fa-bookmark'></i>
          <span> Save</span>
        </UserMutation>
      </div>
    </div>
  );
}

AnswerActions.propTypes = {
  answer: PropTypes.shape({
    id: PropTypes.string.isRequired,
    upvotedBy: PropTypes.array.isRequired,
    downvotedBy: PropTypes.array.isRequired,
  }).isRequired,
};

export default AnswerActions;
